import { useTranslation } from "react-i18next";

import { SliderPageWrapper } from "components/layout/sliderPageWrapper/SliderPageWrapper";
import { StatementTable } from "./statementTable/statementTable";

import classes from "./Statements.module.scss";

export const Statements = () => {
  const { t } = useTranslation(["common", "eStatements"]);

  return (
    <SliderPageWrapper
      headerTitle={t("eStatements:header_title")}
      preserveHeadingCase
    >
      <section className={classes.Wrapper}>
        
        <StatementTable />
      </section>
    </SliderPageWrapper>
  );
};
